interface Tag {
  key: string;
  value: string;
}

const gameGenreMainKey = 'GENRE';
const gameGenreKeyRegexp = new RegExp(`^${gameGenreMainKey}_[1-9]+$`);

function createGameGenreKey(value: number) {
  if (value < 1) {
    throw new Error('Serial number of game genre key must be 1 or more');
  }
  return `${gameGenreMainKey}_${value}`;
}

function createGameGenreTag(gameGenre: string, value: number): Tag {
  return {
    key: createGameGenreKey(value),
    value: gameGenre,
  };
}

function checkGameGenreTag(tag: Tag) {
  return gameGenreKeyRegexp.test(tag.key);
}

function transformGameGenresToTags(gameGenres: string[]): Tag[] {
  return gameGenres.map((gameGenre, i) => createGameGenreTag(gameGenre, i + 1));
}

function transformTagsToGameGenres(tags: Tag[]) {
  return tags.filter(checkGameGenreTag).map((tag) => tag.value);
}

export {
  createGameGenreKey,
  createGameGenreTag,
  checkGameGenreTag,
  transformTagsToGameGenres,
  transformGameGenresToTags,
};
